import {useState} from "react";
import {useResizeListener} from "../../../listeners/SystemResizeListener";
import {isNullOrUndefined} from "../../../services/Validator";
import GameDetailedScreen from "../../../screens/games/GameDetailedScreen";

export function GamesItem({game}) {
    // Used in GamesList to display one single Games
    // item made of background image, name and goal

    // PROPERTIES
    const [isModalOpen, setIsModalOpen] = useState(false)

    // HOOKS
    // ---- Eventually close modal during screen resize
    useResizeListener(() => setIsModalOpen(false))

    // BUILD
    if (isNullOrUndefined(game))
        return null
    return (
        <div className="bg-backgroundLight4 hover:bg-backgroundLight5 cursor-pointer rounded-[12px] overflow-hidden h-[304px] border-[1px] border-transparent hover:border-primaryLight1"
            onClick={processModalOpening}>
            {/** TERM MODAL */}
            <GameDetailedScreen open={isModalOpen}
                                handleClose={processModalClosing}
                                game={game} />

            {/** CORE */}
            <div className="h-[65%] w-full ">
                <img className="w-full h-full object-cover object-center"
                     src={game?.background}
                     alt="Courrier"/>
            </div>
            <div className="h-[35%] px-[12px] py-[8px] flex flex-col justify-start">
                <h2 className="text-[16px] font-semibold truncate">
                    {game?.title}
                </h2>
                <p className="text-[14px] text-greyLight7 line-clamp-3 mt-[4px]">
                    {game?.description}
                </p>
            </div>
        </div>
    );

    // METHODS
    // ---- LOGIC : Open modal process
    function processModalOpening() {
        if (!isModalOpen) {
            setIsModalOpen(true);
        }
    }

    // ---- LOGIC : Close modal process
    function processModalClosing() {
        if (isModalOpen) {
            setIsModalOpen(false)
        }
    }
}